import Vue from 'vue'
import VueRouter from 'vue-router'
// Components
import AuthForgotPassword from '../views/auth/ForgotPassword'
import AuthLogin from '../views/auth/Login'
import AuthResetPassword from '../views/auth/ResetPassword'

import Home from '../views/Home.vue'
//Middleware
import Middleware from '../middleware/index';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            middleware: [Middleware.guest]
        }
    },

    {
        path: '/about',
        name: 'About',
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
        path: '/auth/forgot-password',
        name: 'AuthForgotPassword',
        component: AuthForgotPassword,
        meta: {
            title: 'Passwort vergessen',
            middleware: [Middleware.guest]
        }
    },
    {
        path: '/auth/login',
        name: 'AuthLogin',
        component: AuthLogin,
        meta: {
            title: 'Login',
            middleware: [Middleware.guest]
        }
    },
    {
        path: '/auth/reset-password',
        name: 'AuthResetPassword',
        component: AuthResetPassword,
        meta: {
            title: 'Passwort zurücksetzen',
            middleware: [Middleware.guest]
        }
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/user-area/Dashboard'),
        meta: {
            title: 'Dashboard',
            middleware: [Middleware.auth, Middleware.checkPermissions]
        }
    },
    {
        path: '/employee-interviews',
        name: 'EmployeeInterviewsDashboard',
        component: () => import(/* webpackChunkName: "employee-interview-dashboard" */ '../views/user-area/EmployeeInterviews/Dashboard'),
        meta: {
            title: 'Dashboard • Mitarbeitergespräche',
            middleware: [Middleware.auth]
        },
    },
    {
        path: '/employee-interviews/create',
        name: 'EmployeeInterviewsCreate',
        component: () => import(/* webpackChunkName: "employee-interview-create" */ '../views/user-area/EmployeeInterviews/Create'),
        meta: {
            title: 'Neu anlegen • Mitarbeitergespräche',
            middleware: [Middleware.auth],
            permissionsAny: ['create interview employee', 'create interview test']
        }
    },
    {
        path: '/employee-interviews/edit/:id',
        name: 'EmployeeInterviewsEdit',
        component: () => import(/* webpackChunkName: "employee-interview-show" */ '../views/user-area/EmployeeInterviews/Edit'),
        meta: {
            title: 'Ansicht • Mitarbeitergespräche',
            middleware: [Middleware.auth]
        }
    },
    {
        path: '/employee-interviews/employees',
        name: 'EmployeeInterviewsEmployees',
        component: () => import(/* webpackChunkName: "employee-interview-employees" */ '../views/user-area/EmployeeInterviews/Employees'),
        meta: {
            title: 'Mitarbeiter • Mitarbeitergespräche',
            middleware: [Middleware.auth]
        }
    },
    {
        path: '/employee-interviews/employees/show/:id',
        name: 'EmployeeInterviewsEmployeesShow',
        component: () => import(/* webpackChunkName: "employee-interview-employees" */ '../views/user-area/EmployeeInterviews/Employees-Show'),
        meta: {
            title: 'Mitarbeiteransicht • Mitarbeitergespräche',
            middleware: [Middleware.auth]
        }
    },
    {
        path: '/employee-interviews/index',
        name: 'EmployeeInterviewsIndex',
        component: () => import(/* webpackChunkName: "employee-interview-index" */ '../views/user-area/EmployeeInterviews/Index'),
        meta: {
            title: 'Übersicht • Mitarbeitergespräche',
            middleware: [Middleware.auth]
        }
    },
    {
        path: '/employee-interviews/own',
        name: 'EmployeeInterviewsOwn',
        component: () => import(/* webpackChunkName: "employee-interview-own" */ '../views/user-area/EmployeeInterviews/Own'),
        meta: {
            title: 'Eigene Gespräche • Mitarbeitergespräche',
            middleware: [Middleware.auth, Middleware.checkPermissions],
            permissions: ['show interview own']
        }
    },
    {
        path: '/employee-interviews/analysis/dashboard',
        name: 'EmployeeInterviewsAnalysisDashboard',
        component: () => import(/* webpackChunkName: "employee-interview-analysis-export" */ '../views/user-area/EmployeeInterviews/Analysis-Dashboard'),
        meta: {
            title: 'Dashboard • Auswertung • Mitarbeitergespräche',
            middleware: [Middleware.auth],
            permissions: ['perform export']
        }
    },
    {
        path: '/employee-interviews/analysis/export',
        name: 'EmployeeInterviewsAnalysisExport',
        component: () => import(/* webpackChunkName: "employee-interview-analysis-export" */ '../views/user-area/EmployeeInterviews/Analysis-Export'),
        meta: {
            title: 'Export • Auswertung • Mitarbeitergespräche',
            middleware: [Middleware.auth],
            permissions: ['perform export']
        }
    },

    {
        path: '/ideas-workbench/',
        name: 'IdeasWorkbenchDashboard',
        component: () => import(/* webpackChunkName: "ideas-workbench" */ '../views/user-area/IdeasWorkbench/Dashboard'),
        meta: {
            title: 'Dashboard • WerkBank',
            middleware: [Middleware.auth],
            permissions: ['view ideasWorkbench']
        }
    },

    {
        path: '/ideas-workbench/categories/create',
        name: 'IdeasWorkbenchCategoriesCreate',
        component: () => import(/* webpackChunkName: "ideas-workbench-categories-create" */ '../views/user-area/IdeasWorkbench/Categories-Create'),
        meta: {
            title: 'Kategorie erstellen • WerkBank',
            middleware: [Middleware.auth],
            permissions: ['store ideasCategory']
        }
    },

    {
        path: '/ideas-workbench/categories/edit/:id',
        name: 'IdeasWorkbenchCategoriesEdit',
        component: () => import(/* webpackChunkName: "ideas-workbench-categories-create" */ '../views/user-area/IdeasWorkbench/Categories-Create'),
        meta: {
            title: 'Kategorie bearbeiten • WerkBank',
            middleware: [Middleware.auth],
            permissions: ['store ideasCategory']
        }
    },

    {
        path: '/ideas-workbench/categories/show/:id',
        name: 'IdeasWorkbenchCategoriesShow',
        component: () => import(/* webpackChunkName: "ideas-workbench-categories-show" */ '../views/user-area/IdeasWorkbench/Categories-Show'),
        meta: {
            title: 'Kategorie Ansicht • WerkBank',
            middleware: [Middleware.auth],
            permissions: ['view ideasWorkbench']
        }
    },

    {
        path: '/ideas-workbench/ideas/create/',
        name: 'IdeasWorkbenchIdeasCreate',
        component: () => import(/* webpackChunkName: "ideas-workbench-ideas-create" */ '../views/user-area/IdeasWorkbench/Ideas-Create'),
        meta: {
            title: 'Neue Idee • WerkBank',
            middleware: [Middleware.auth],
            permissions: ['view ideasWorkbench']
        }
    },

    {
        path: '/ideas-workbench/ideas/edit/:id',
        name: 'IdeasWorkbenchIdeasEdit',
        component: () => import(/* webpackChunkName: "ideas-workbench-ideas-create" */ '../views/user-area/IdeasWorkbench/Ideas-Create'),
        meta: {
            title: 'Idee bearbeiten • WerkBank',
            middleware: [Middleware.auth],
            permissions: ['view ideasWorkbench']
        }
    },

    {
        path: '/ideas-workbench/ideas/show/:id',
        name: 'IdeasWorkbenchIdeasShow',
        component: () => import(/* webpackChunkName: "ideas-workbench-ideas-show" */ '../views/user-area/IdeasWorkbench/Ideas-Show'),
        meta: {
            title: 'Idee Ansicht • WerkBank',
            middleware: [Middleware.auth],
            permissions: ['view ideasWorkbench']
        }
    },

    {
        path: '/settings/orga-units',
        name: 'SettingsOrgaUnits',
        component: () => import(/* webpackChunkName: "settings-orga-units" */ '../views/user-area/Settings/OrgaUnits'),
        meta: {
            title: 'Organisationseinheiten • Einstellungen',
            middleware: [Middleware.auth, Middleware.checkPermissions],
            permissions: ['update applicationSettings']
        }
    },
    {
        path: '/settings/users',
        name: 'SettingsUsers',
        component: () => import(/* webpackChunkName: "settings-users" */ '../views/user-area/Settings/Users'),
        meta: {
            title: 'Nutzer • Einstellungen',
            middleware: [Middleware.auth, Middleware.checkPermissions],
            permissions: ['update applicationSettings']
        }
    },

    {
        path: '/settings/users/create',
        name: 'SettingsUsersCreate',
        component: () => import(/* webpackChunkName: "settings-users-create" */ '../views/user-area/Settings/Users/Create'),
        meta: {
            title: 'Nutzer anlegen • Einstellungen',
            middleware: [Middleware.auth, Middleware.checkPermissions],
            permissions: ['update applicationSettings']
        }
    },

    {
        path: '/settings/users/edit/:id',
        name: 'SettingsUsersEdit',
        component: () => import(/* webpackChunkName: "settings-users-edit" */ '../views/user-area/Settings/Users/Edit'),
        meta: {
            title: 'Nutzer Ansicht • Einstellungen',
            middleware: [Middleware.auth, Middleware.checkPermissions],
            permissions: ['update applicationSettings']
        }
    },

    {
        path: '/user/profile',
        name: 'UserProfile',
        component: () => import(/* webpackChunkName: "employee-user-profile" */ '../views/user-area/User/Profile'),
        meta: {
            title: 'Profil',
            middleware: [Middleware.auth]
        }
    },
];

//

const router = new VueRouter({
    mode: 'history',
    // eslint-disable-next-line no-unused-vars
    scrollBehavior: function (to) {
        if (to.hash) {
            return {
                selector: to.hash
            }
        }
    },
    base: process.env.BASE_URL,
    routes,

});

function nextCheck(context, middleware, index) {
    const nextMiddleware = middleware[index];

    if (!nextMiddleware) return context.next;

    return (...parameters) => {
        context.next(...parameters);
        const nextMidd = nextCheck(context, middleware, index + 1);

        nextMiddleware({...context, next: nextMidd});
    }
}

router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

        const ctx = {
            from,
            next,
            router,
            to
        };

        const nextMiddleware = nextCheck(ctx, middleware, 1);

        return middleware[0]({...ctx, next: nextMiddleware});
    }

    return next();
});


router.afterEach((to) => {
    Vue.nextTick(() => {
        document.title = to.meta.title ? to.meta.title + ' • MitarbeiterServices' : 'MitarbeiterServices'
    })
});


export default router
